var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.goBack}},[_c('b-icon',{attrs:{"icon":"chevron-left"}}),_vm._v(" "+_vm._s(_vm.$t('common.goback'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }